import { utils } from '@tfo/common'
import { action, observable } from 'mobx'
import { LoginType } from '../models/Enums'
import RootStore from './RootStore'
import $http from '../utils/$http'
import { IIndividualLoginResponse } from '../models/Interfaces'

export class LoginStore {
	@observable public nationalId: string = ''
	@observable public selectedLoginType: LoginType
	@observable public rootStore: RootStore
	@observable public hasError: boolean = false
	@observable public bankIDError: boolean = false
	@observable public openBankID: boolean = false
	@observable public showMenu: boolean = false
	@observable public loading: boolean = false
	@observable public bankIDStatusText: string
	@observable public bankIDErrorText: string

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore

		let hrefQuery = new URLSearchParams(document.location.search);
		if (hrefQuery.get("loginWith") === "verificationCode") {
			this.setLoginType(LoginType.VerificationCode);
		}
	}

	@action public onChange(key: string, value: string) {
		this[key] = value
	}

	@action public onShowMenu() {
		this.showMenu = !this.showMenu
	}

	@action public onSelectLoginType(value: LoginType) {
		this.selectedLoginType = value
		this.showMenu = false
		this.resetError()
	}

	@action public setLoginType(value: LoginType) {
		this.selectedLoginType = value
	}

	@action public onKeyDown(e: any) {
		if (e == 13 && this.loading === false) {
			this.onLogin()
		}
	}

	@action public resetError() {
		this.hasError = false
		this.bankIDError = false
		this.bankIDErrorText = ''
		this.bankIDStatusText = ''
	}

	@action public onLogin() {
		this.resetError()
		this.loading = true

		this.hasError = false
		const credentials = {
			nationalId: {
				value: this.nationalId,
				country: 'SE',
			},
			bankIdLoginType: this.selectedLoginType,
		}

		return $http.post('authentication/bankid/auth', credentials)
			.then((response: any) => {
				this.openBankID = true
				this.checkBankId(response.orderRef)
			})
			.catch(error => {
				/* tslint:disable */
				console.error(error)
				this.hasError = true
				this.loading = false
			})

	}

	@action public async checkBankId(orderRef: string) {
		var time = 1
		var interval = setInterval(async () => {
			if (time <= 40) {
				const response: any = await $http.post('authentication/bankid/collect',
					{ orderRef: orderRef },
				)
				this.bankIDErrorText = ''

				if (response.status === 'Complete') {
					clearInterval(interval)

					response.user.lastActivity = new Date()

					this.setCookieData(response.user)

					window.location.href = '/candidate'
				}
				if (response.status === 'Failed') {
					clearInterval(interval)
					this.bankIDError = true
					this.bankIDStatusText = ''
					this.bankIDErrorText = response.bankIdUserMessage.swedishText
					this.loading = false

					$http.post('authentication/bankid/cancel',
						{ orderRef: orderRef },
					)
				}
				if (response.status === 'Pending') {
					time++
					this.bankIDStatusText = response.bankIdUserMessage.swedishText
				}
			} else {
				clearInterval(interval)

				$http.post('authentication/bankid/cancel',
					{ orderRef: orderRef },
				)
				this.hasError = false
				this.bankIDError = true
				this.bankIDStatusText = ''
				this.loading = false
			}
		}, 2000)
	}

	@action private setCookieData(cookieData: any) {
		const deleteArray = ['roles']
		deleteArray.forEach(e => {
			delete cookieData[e]
		})
		utils.setCookie(JSON.stringify(cookieData))
	}

	@action public onBankIdLogin(encryptedCompletionData: string) {
		this.loading = true

		return $http.post<IIndividualLoginResponse>('authentication/bankid/login', {
			encryptedCompletionData: encryptedCompletionData,
		}).then((data: IIndividualLoginResponse) => {
			data.lastActivity = new Date()

			this.setCookieData(data)

			window.location.href = '/candidate'
		})
			.catch((e) => {
				console.log(e)
			})
			.finally(() => {
				this.loading = false
			})
	}
}
